/**
 * 用户信息全局存储模块
 * 用于统一管理用户信息的缓存和获取
 */

// 用户信息缓存
let userInfo = {
  userId: null,
  userName: ''
}

/**
 * 设置用户信息
 * @param {Object} info - 用户信息对象
 * @param {string|null} info.userId - 用户ID
 * @param {string} info.userName - 用户名称
 */
export function setUserInfo(info) {
  userInfo = {
    userId: info.userId || null,
    userName: info.userName || ''
  }
}

/**
 * 获取用户信息
 * @returns {Object} 用户信息对象
 */
export function getUserInfo() {
  return { ...userInfo }
}

/**
 * 获取用于记录操作日志的用户信息。
 * PDA 未获取到完整用户信息时，统一记录为系统后台。
 * @returns {Object} 操作人信息
 */
export function getOperationUser() {
  if (userInfo.userId && userInfo.userName) {
    return { ...userInfo }
  }

  return {
    userId: null,
    userName: '系统后台'
  }
}

/**
 * 获取用户ID
 * @returns {string} 用户ID
 */
export function getUserId() {
  return userInfo.userId
}

/**
 * 获取用户名称
 * @returns {string} 用户名称
 */
export function getUserName() {
  return userInfo.userName
}

/**
 * 清除用户信息
 */
export function clearUserInfo() {
  userInfo = {
    userId: null,
    userName: ''
  }
}

export default {
  setUserInfo,
  getUserInfo,
  getOperationUser,
  getUserId,
  getUserName,
  clearUserInfo
}
